import axios from '@/utils/http';

export default params => {
  return axios
    .post('/user/temp_message', params)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
